import React from "react";
import Box from "@vapor/react-material/Box";
import { useTheme } from "@emotion/react";
import Stack from "@vapor/react-material/Stack";

type sectionProps = {
  children?: React.ReactNode;
  divider?: boolean;
  direction?: "row" | "column";
};

const Section = ({
  children,
  divider = false,
  direction = "column"
}: sectionProps) => {
  let theme = useTheme();

  const sectionStyle = {
    display: "flex",

    marginLeft: "24px",
    marginRight: "24px",

    borderBottom: (e) => {
      return divider && `1.5px solid ${e.palette.primary.borderDefault}`;
    },
    paddingTop: "24px",
    paddingBottom: "24px",
    "@media screen and (min-width: 1536px)": {
      paddingTop: "32px",
      paddingBottom: "32px",
      marginLeft: "32px",
      marginRight: "32px"
    },
    "@media screen and (max-width: 1200px)": {
      paddingTop: "16px",
      paddingBottom: "16px",
      marginLeft: "16px",
      marginRight: "16px"
    }
  };
  return (
    <Box
      sx={{
        ...sectionStyle
      }}
    >
      {direction === "row" ? (
        children
      ) : (
        <Stack sx={{ width: "100%" }}>{children}</Stack>
      )}
    </Box>
  );
};

export default Section;
